//#region src/bite_log_simple_event.ts
var BiteLogSimpleEvent = /* @__PURE__ */ function(BiteLogSimpleEvent) {
	BiteLogSimpleEvent[BiteLogSimpleEvent["Unrecognized"] = -1] = "Unrecognized";
	BiteLogSimpleEvent[BiteLogSimpleEvent["SimpleStatusOk"] = 0] = "SimpleStatusOk";
	return BiteLogSimpleEvent;
}(BiteLogSimpleEvent || {});
//#endregion
export { BiteLogSimpleEvent };

//# sourceMappingURL=bite_log_simple_event.js.map